declare let window: any;

/**
 * Pushes Journey event data to GTM's dataLayer.
 * GTM owns all ad-platform translation — this function just provides
 * the Journey event identity and shared event ID.
 *
 * Each ad platform has its own Regex Table Variable in GTM that
 * maps journey_category + journey_event_name to that platform's
 * standard event names. Adding a new platform requires zero code changes.
 */
export function trackJourneyEventInGTM(
  categoryName: string,
  eventName: string,
  clientEventId: string,
): void {
  if (typeof window === 'undefined') return;

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'journey_event',
    journey_category: categoryName,
    journey_event_name: eventName,
    journey_event_id: clientEventId,
  });
}
